import styled from "styled-components";
import buildColor from "@fdr/static-ui/ColorPalette";
import { fontCondensed } from "@fdr/static-ui/Typography";

export const Card = styled.div`
  width: 100%;
  background-color: ${buildColor("white")};
  padding: 12px 0;
  border-bottom: 1px solid ${buildColor("grey", "L3")};
`;

export const Body = styled.div`
  background-color: ${buildColor("grey", "L4")};
`;

export const RunnerTag = styled.span`
  font-size: 14px;
  font-weight: 400;
  text-transform: uppercase;
  font-family: ${fontCondensed};
  line-height: 12px;
  padding: 2px 4px;
  background-color: ${buildColor("grey", "L3")};
`;

export const RunnerTagDescription = styled.div`
  padding-right: 4px;
  margin-top: 8px;
  font-size: 14px;
  line-height: 125%;
  font-family: "Proxima nova", sans-serif;
  > div > ul {
    margin-left: 8px;
    list-style: disc;
  }
`;

export const CardsList = styled.div`
  padding-left: 16px;
  background-color: ${buildColor("white")};
  &:first-of-type {
    margin-bottom: 16px;
  }
`;

export const ListTitle = styled.div`
  width: 100%;
  display: flex;
  padding: 12px 0;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  font-family: "Proxima nova", sans-serif;
  border-bottom: 1px solid ${buildColor("grey", "L3")};
  flex-direction: row;
  align-items: center;

  > span {
    margin-left: 8px;
    margin-right: 4px;
  }
`;
